/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

// TODO ugly fix for rjsf lacking of proper support optional null notation. Eg "type": ["object, "null"]
// ui generation got corrupted in this case, and backend expects that to not to return
// unexpected validation errors
export default function sanitizeSchema(json) {
  const pattern = /\[\s*"object"\s*,\s*"null"\s*\]/g;
  let string = JSON.stringify(json);
  string = string.replace(pattern, '"object"');
  return JSON.parse(string);
}
